import _ from 'lodash';

import PropTypes from 'prop-types';

import { cmsService } from '../services/homii-services';

import HeroSection from '../components/corporate-pages-content/hero-section.component';
import DifferenceSection from '../components/corporate-pages-content/difference-section.component';
import BusinessTravelSection from '../components/corporate-pages-content/business-travel-section.component';
import ImageSection from '../components/corporate-pages-content/image-section.component';

import MobileAppSection from '../components/home-page-components/mobile-app-section.component';
import CorporateBookingsForm from '../components/get-in-touch-components/corporate-bookings-form.component';

import { Layout, Footer, MetaData } from '../components/shared';

const CorporateBookings = (props) => {    
    const { data, baseUrlApp } = props;
    const seoTitle = _.get(data, 'acf.seo_title');
    const seoMetaDesc = _.get(data, 'acf.seo_meta_description');
    const heroTitle = _.get(data, 'acf.hero_title');
    const heroImgSrc = _.get(data, 'acf.hero_main_image');
    const heroImgAlt = _.get(data, 'acf.hero_main_image_alt');
    const differenceTitle = _.get(data, 'acf.difference_section_title');
    const differenceParagraph = _.get(data, 'acf.difference_section_paragraph');
    const differenceImgSrc = _.get(data, 'acf.difference_section_image.url');
    const differenceImgAlt = _.get(data, 'acf.difference_section_image_alt');
    const businessTravelTitle = _.get(data, 'acf.business_travel_section_title');
    const businessTravelParagraph = _.get(data, 'acf.business_travel_section_paragraph');
    const businessTravelImgSrc = _.get(data, 'acf.business_travel_section_image.url');
    const businessTravelImgAlt = _.get(data, 'acf.business_travel_section_image_alt');
    const businessTravelIcons = _.get(data, 'acf.icons');
    const imageSrc = _.get(data, 'acf.image_section_image.url');
    const imageAlt = _.get(data, 'acf.image_section_image_alt');
    const imageQuoteTitle = _.get(data, 'acf.image_section_quote_title');
    const imageQuoteParagraph = _.get(data, 'acf.image_section_quote_paragraph');
    const imageQuoteAuthorDetails = _.get(data, 'acf.image_section_quote_author_details');
    const mobileAppTitle = _.get(data, 'acf.mobile_title');
    const mobileAppParagraph = _.get(data, 'acf.mobile_paragraph');
    const mobileAppIcon = _.get(data, 'acf.mobile_icon.url');
    const mobileAppIconText = _.get(data, 'acf.mobile_icon_text');
    const mobilePrimaryImgSrc = _.get(data, 'acf.mobile_primary_image.url');
    const mobilePrimaryImgAlt = _.get(data, 'acf.mobile_primary_image_alt');
    const mobileAppSecondaryImgSrc = _.get(data, 'acf.mobile_secondary_image.url');
    const mobileAppSecondaryImgAlt = _.get(data, 'acf.mobile_secondary_image_alt');

    return (
        <Layout>

            <MetaData
                title={seoTitle}
                desc={seoMetaDesc}
                canonical={`${baseUrlApp}/corporate-bookings`}
            />

            <div className='corporate-container'>
                <HeroSection
                    title={heroTitle}
                    imgSrc={heroImgSrc}
                    imgAlt={heroImgAlt}
                    id="corporate_bookings_header"
                />
            </div>

           <DifferenceSection
                title={differenceTitle}
                paragraph={differenceParagraph}
                imgSrc={differenceImgSrc}
                imgAlt={differenceImgAlt}
            />

            <BusinessTravelSection
                title={businessTravelTitle}
                paragraph={businessTravelParagraph}
                imgSrc={businessTravelImgSrc}
                imgAlt={businessTravelImgAlt}
                icons={businessTravelIcons}
            />

            <ImageSection
                imgSrc={imageSrc}
                imgAlt={imageAlt}
                title={imageQuoteTitle}
                paragraph={imageQuoteParagraph}
                authorDetails={imageQuoteAuthorDetails}
            />

            <div className='container-root container-root-maxWidthLg'>
                <CorporateBookingsForm />
            </div>

           <div className='corporate-container'>
                <MobileAppSection
                    isDark                   
                    title={mobileAppTitle}
                    paragraph={mobileAppParagraph}
                    icon={mobileAppIcon}
                    iconText={mobileAppIconText}
                    primaryImgSrc={mobilePrimaryImgSrc}
                    primaryImgAlt={mobilePrimaryImgAlt}
                    secondaryImgSrc={mobileAppSecondaryImgSrc}
                    secondaryImgAlt={mobileAppSecondaryImgAlt}
                />
            </div> 

            <Footer />

        </Layout>
    );
};

export default CorporateBookings;

export const getServerSideProps = async ({ }) => {
    const resp = await cmsService.RetrieveWordPressPage('corporate-bookings');    
    return {
        props: {
            data: resp
        }
    };
};


CorporateBookings.propTypes = {
    data: PropTypes.object,
    baseUrlApp: PropTypes.string,
};
